
export const MODULES = {
  LEAVE_APPROVALS: {
    label: "Leave",
    category_code: "LEAVE_APPROVALS",
  },
  REGULARIZATION_MANAGEMENT: {
    label: "Regularization",
    category_code: "REGULARIZATION_MANAGEMENT",
  },
  TIMESHEET_MANAGEMENT: {
    label: "Timesheet",
    category_code: "TIMESHEET_MANAGEMENT",
  },
  EMPLOYEE_SELF_SERVICE: {
    label: "Game Booking",
    category_code: "EMPLOYEE_SELF_SERVICE",
  },
  MY_PROFILE: {
    label: "My Profile",
    category_code: "EMPLOYEE_PROFILE",
  },
  ORG_CHART: {
    label: "OrgChart",
    category_code: "ORG_CHART_APPROVALS"
  },
  /** Separation / exit — `permissionCode` on workflow definitions from the API. */
  SEPARATION: {
    label: "Resignation",
    category_code: "SEPARATION",
  },
  TERMINATION: {
    label: "Termination",
    category_code: "TERMINATION",
  },
};